'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RailCardOption;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _basketHelpers = require('helpers/basketHelpers');

var _emailStyleTools = require('helpers/emailStyleTools');

var _OptionHeader = require('components/TemplateComponents/common/OptionHeader');

var _OptionHeader2 = _interopRequireDefault(_OptionHeader);

var _RailCardJourney = require('./RailCardJourney');

var _RailCardJourney2 = _interopRequireDefault(_RailCardJourney);

var _RailCardTotal = require('./RailCardTotal');

var _RailCardTotal2 = _interopRequireDefault(_RailCardTotal);

var _RailCardJourneyHeader = require('./RailCardJourneyHeader');

var _RailCardJourneyHeader2 = _interopRequireDefault(_RailCardJourneyHeader);

var _RailCardServiceDetails = require('./RailCardServiceDetails');

var _RailCardServiceDetails2 = _interopRequireDefault(_RailCardServiceDetails);

var _Rules = require('components/TemplateComponents/common/Rules');

var _Rules2 = _interopRequireDefault(_Rules);

var _Disclaimer = require('components/common/Disclaimer');

var _Disclaimer2 = _interopRequireDefault(_Disclaimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RailCardOption(_ref) {
  var components = _ref.components,
      option = _ref.option,
      optionNumber = _ref.optionNumber,
      timeFormat = _ref.timeFormat,
      t = _ref.t;

  var rules = option.rules;
  var lastDateToPurchase = (0, _basketHelpers.getLastDateToPurchase)(option);
  var selectedTimeFormat = timeFormat;

  var styleRailCardOptionContainer = (0, _emailStyleTools.containerStyles)(components, 'RailCardOptionContainer');
  var styleRailCardOptionLabel = (0, _emailStyleTools.textStyles)(components, 'RailCardOptionLabel');
  var styleRailCardCommentContainer = (0, _emailStyleTools.containerStyles)(components, 'RailCardCommentContainer');
  var styleRailCardComment = (0, _emailStyleTools.textStyles)(components, 'RailCardComment');
  var styleRailCardRulesText = (0, _emailStyleTools.textStyles)(components, 'RailCardRules');
  var renderDisclaimer = function renderDisclaimer(disclaimer) {
    if (disclaimer) {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Disclaimer2.default, { padTen: _emailStyleTools.padTen,
            containerStyle: styleRailCardCommentContainer,
            textStyle: styleRailCardComment,
            text: disclaimer
          })
        )
      );
    } else {
      return '';
    }
  };

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'RailCardOption' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_OptionHeader2.default, {
            containerStyle: styleRailCardOptionContainer,
            textStyle: styleRailCardOptionLabel,
            text: t('common.option') + ' ' + optionNumber
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_RailCardJourneyHeader2.default, {
            cardTypeText: option.cardTypeText
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_RailCardJourney2.default, {
            logo: option.logo,
            journey: option.journey,
            validFrom: option.validFrom,
            validTo: option.validTo
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_RailCardServiceDetails2.default, {
            className: option.className,
            classCode: option.classCode,
            operatedBy: option.operatedBy,
            equipment: option.equipment,
            tariffcode: option.tariffCode,
            passengertype: option.passengerTypeCode,
            discount: option.discount
          })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_RailCardTotal2.default, {
            price: option.price,
            currencyCode: option.currencyCode
          })
        )
      ),
      renderDisclaimer(option.disclaimer),
      option.rules && _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Rules2.default, { rules: option.rules, style: styleRailCardRulesText })
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/RailCard/Email/RailCardOption.jsx
// module id = 1549
// module chunks = 0